

export default {
    name: 'MeatPageSupplierDescription',
    props: {
        data: { type: Object, default: () => ({}) },
        common: { type: Object, default: () => ({}) }
    },
}
